"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function HeroLive(_a) {
    var className = _a.className, livestreams = _a.livestreams;
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: storybook_1.Helpers.classNames('storybook-home-hero', className) },
            react_1.default.createElement("h1", null,
                "Kijk nu ",
                react_1.default.createElement("span", { className: "storybook-home-hero-count" },
                    livestreams.meta.total,
                    " wedstrijden"),
                " ",
                react_1.default.createElement("span", { className: 'storybook-home-hero-live' }, "LIVE")),
            react_1.default.createElement("a", { href: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/videos/livestreams" },
                react_1.default.createElement("span", null, "Alle livestreams"),
                react_1.default.createElement(storybook_1.Icons.Icon, { name: 'arrow-narrow-right' }))),
        react_1.default.createElement(storybook_1.Home.LiveVideos, { livestreams: livestreams }));
}
exports.default = HeroLive;
